'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { useEffect, useState } from 'react';
import { CrmSuiteCards } from '../../constants/MerchCardsToShow';
import { TAB_IDS } from '../../constants/Mon569SidenavConfig';
import { isMon569WidthMobile } from '../product-pages/mobileUtils';
import * as ProductLevels from 'self-service-api/constants/ProductLevels';
import debounce from 'pricing-pages-unified-ui/utils/wtDebounce';
import { IsMobileContext } from '../suite-page/CrmSuiteTopSection/SuiteTiles';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import styled from 'styled-components';
import { SuiteTile } from '../suite-page/CrmSuiteTopSection/SuiteTile';
import Mon569MobileProductLevelSelector from './Mon569MobileProductLevelSelector';
import { borderStyle, StyledCardGrid } from '../common/MerchCardSharedComponents';
const SelectorButtonWrapper = styled.div.withConfig({
  displayName: "Mon569SuiteTiles__SelectorButtonWrapper",
  componentId: "zr6qrg-0"
})(["display:flex;margin:0 auto 20px;width:inherit;", ""], breakpoint.phoneLarge(_t || (_t = _`
    flex-direction: column;
  `)));

const Mon569SuiteTiles = ({
  selectedTab
}) => {
  const [isMobile, setIsMobile] = useState(isMon569WidthMobile(window.innerWidth));
  useEffect(() => {
    const resizeWindow = debounce(() => {
      setIsMobile(isMon569WidthMobile(window.innerWidth));
    }, 250);
    window.addEventListener('resize', resizeWindow);
    return () => window.removeEventListener('resize', resizeWindow);
  }, []);
  const productLevelsToShow = selectedTab === TAB_IDS.starter ? CrmSuiteCards.slice(0, CrmSuiteCards.indexOf(ProductLevels.PROFESSIONAL)) : CrmSuiteCards.slice(CrmSuiteCards.indexOf(ProductLevels.PROFESSIONAL));
  const suiteCardComponents = productLevelsToShow.map((productLevel, index) => {
    const commonStyles = {
      msGridColumn: index + 1,
      // IE
      gridColumnStart: index + 1,
      paddingLeft: 32,
      paddingRight: 32,
      borderRight: index < productLevelsToShow.length - 1 ? borderStyle : 'none'
    };
    return /*#__PURE__*/_jsx(SuiteTile, {
      productLevel: productLevel,
      commonStyles: commonStyles
    }, productLevel);
  });
  return /*#__PURE__*/_jsxs(IsMobileContext.Provider, {
    value: isMobile,
    children: [isMobile && /*#__PURE__*/_jsx(SelectorButtonWrapper, {
      children: /*#__PURE__*/_jsx(Mon569MobileProductLevelSelector, {
        isSuite: true
      })
    }), /*#__PURE__*/_jsx(StyledCardGrid, {
      columns: productLevelsToShow.length,
      maxColumns: 2,
      children: suiteCardComponents
    })]
  });
};

export default Mon569SuiteTiles;